import { render, staticRenderFns } from "./StoricoRinnoviDialog.vue?vue&type=template&id=a232ca2c&"
import script from "./StoricoRinnoviDialog.vue?vue&type=script&lang=js&"
export * from "./StoricoRinnoviDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports